// extracted by mini-css-extract-plugin
export var arrow = "_ks-1";
export var content = "_ks-0";
export var highlighted = "_ks-2";